export default {
  kameraplaner: {
    intro: {
      badge: 'Herramienta de planificación interactiva – gratuita y sin compromiso',
      title: 'Planifique su sistema de cámaras con antelación',
      lead:
        'Con el planificador de cámaras de SSG puede dibujar habitaciones o superficies, marcar puertas, ventanas y zonas de vigilancia importantes, y probar posibles posiciones de cámara. Obtendrá una primera valoración visual que después puede ser revisada profesionalmente por SSG Signaltechnik.',
      noReg: 'Sin registro',
      localSave: 'Guardado localmente en el navegador',
      noBinding: 'Sin número vinculante de cámaras',
      quickTitle: 'Iniciar comprobación rápida',
      quickDesc:
        'Responda preguntas sobre su propiedad, las zonas de vigilancia deseadas y las funciones en cinco pasos breves. Obtendrá de inmediato un resumen claro.',
      quickList: { '0': 'Tipo de propiedad y zonas a vigilar', '1': 'Funciones deseadas y datos de la propiedad', '2': 'Resumir el resultado y enviarlo directamente' },
      quickCta: 'Iniciar comprobación rápida',
      plannerTitle: 'Planificar el plano usted mismo',
      plannerDesc:
        'Dibuje habitaciones y paredes, coloque puertas, ventanas, obstáculos y cámaras, con conos de visión, análisis de cobertura y sugerencias automáticas de posiciones.',
      plannerList: { '0': 'Superficie de dibujo con rejilla y escala en metros', '1': 'Conos de visión, objetivos de vigilancia y zonas privadas', '2': 'Carga de plano, evaluación e impresión' },
      plannerCta: 'Planificar el plano usted mismo',
      savedTitle: 'Hay un plan guardado',
      savedDesc: 'Se guardó automáticamente de forma local y puede continuarse.',
      resume: 'Continuar el último plan',
    },
    quick: {
      steps: { '0': 'Tipo de propiedad', '1': 'Zonas', '2': 'Funciones', '3': 'Datos de la propiedad', '4': 'Resultado' },
      back: 'Volver al resumen',
      title: 'Comprobación rápida',
      subtitle: 'Cinco pasos breves; después recibirá un resumen claro de su plan preliminar.',
      stepOf: 'Paso {{current}} de {{total}}',
      objectQuestion: '¿Qué tipo de propiedad le conviene?',
      chooseOne: 'Seleccione una opción.',
      areasQuestion: '¿Qué zonas deben vigilarse?',
      multiSelect: 'Selección múltiple posible.',
      featuresTitle: 'Funciones deseadas',
      dataTitle: 'Datos de la propiedad',
      dataOptional: 'Todos los datos son opcionales y pueden omitirse.',
      areaSize: 'Superficie total aproximada (m²)',
      roomCount: 'Número de habitaciones o zonas',
      inOut: '¿Interior, exterior o ambos?',
      inside: 'Interior',
      outside: 'Exterior',
      both: 'Ambos',
      maxDistance: 'Mayor distancia de vigilancia estimada',
      pleaseSelect: 'Seleccione',
      distanceUpTo5: 'Hasta 5 metros',
      distance5to10: 'De 5 a 10 metros',
      distance10to20: 'De 10 a 20 metros',
      distanceOver20: 'Más de 20 metros',
      internet: '¿Conexión a internet disponible?',
      network: '¿Cableado de red disponible?',
      power: '¿Electricidad en el punto de montaje?',
      yes: 'Sí',
      no: 'No',
      unknown: 'Desconocido',
      recordingDuration: 'Duración de grabación deseada',
      installType: '¿Sistema nuevo o existente?',
      newSystem: 'Sistema nuevo',
      existingSystem: 'Sistema existente',
      existingManufacturer: 'Fabricante y modelo del sistema existente (si lo conoce)',
      requirements: 'Requisitos especiales',
      requirementsPlaceholder: 'Por ejemplo, condiciones de iluminación especiales, protección patrimonial, condiciones particulares...',
      chars: '{{current}}/500 caracteres',
      ssgCarePre: 'También me interesa',
      ssgCarePost: '– mantenimiento y atención personal del sistema.',
      overviewTitle: 'Su plan preliminar de un vistazo',
      amberNote:
        'Según su información, pueden ser adecuadas varias posiciones o tipos de cámara. Para una recomendación fiable, deben comprobarse los ángulos de visión, la altura de montaje, la iluminación y los obstáculos existentes.',
      planFloorplan: 'Planificar además el plano',
      sendToSsg: 'Enviar datos a SSG',
      editResult: 'Editar resultado',
      backBtn: 'Atrás',
      next: 'Siguiente',
      summary: {
        objectType: 'Tipo de propiedad',
        areas: 'Zonas de vigilancia',
        features: 'Funciones deseadas',
        areaSize: 'Superficie total aproximada',
        roomCount: 'Habitaciones / zonas',
        inOut: 'Zona',
        maxDistance: 'Mayor distancia de vigilancia',
        internet: 'Conexión a internet',
        network: 'Cableado de red',
        power: 'Electricidad en el punto de montaje',
        recordingDuration: 'Duración de grabación',
        installType: 'Sistema',
        existingSystem: 'Sistema existente',
        requirements: 'Requisitos especiales',
        ssgCare: 'Atención SSG Care',
      },
      values: {
        notSpecified: 'No especificado',
        inside: 'Interior',
        outside: 'Exterior',
        inOut: 'Interior y exterior',
        present: 'Disponible',
        notPresent: 'No disponible',
        unknown: 'Desconocido',
        unclear: 'aún sin aclarar',
        newSystem: 'Sistema nuevo',
        existing: 'Sistema existente',
        desired: 'Deseado',
      },
    },
    topbar: {
      projectName: 'Nombre del proyecto',
      undo: 'Deshacer',
      undoTip: 'Deshacer (Ctrl+Z)',
      redo: 'Rehacer',
      redoTip: 'Rehacer (Ctrl+Y)',
      save: 'Guardar temporalmente',
      saved: 'Guardado',
      saveTip: 'Guardar temporalmente',
      reset: 'Restablecer',
      resetTip: 'Restablecer planificador',
      help: 'Ayuda',
      helpTip: 'Abrir la introducción de nuevo',
      evaluate: 'Evaluar plan',
      evaluateTip: 'Evaluar plan',
    },
    tools: {
      select: { label: 'Seleccionar', hint: 'Mover, cambiar tamaño, rotar elementos. Arrastrar espacio vacío = mover.' },
      erase: { label: 'Eliminar', hint: 'Eliminar elemento con un clic.' },
      room: { label: 'Habitación rectangular', hint: 'Dibujar una habitación o superficie arrastrando – las medidas se muestran en vivo.' },
      polygon: { label: 'Superficie libre', hint: 'Dibujar una superficie libre a mano: mantenga pulsado y trace la forma.' },
      wall: { label: 'Pared', hint: 'Dibujar una pared arrastrando – limita las líneas de visión.' },
      door: { label: 'Puerta', hint: 'Colocar una puerta en una pared – luego mover o rotar directamente.' },
      window: { label: 'Ventana', hint: 'Colocar una ventana en una pared – luego mover o rotar directamente.' },
      obstacle: { label: 'Obstáculo', hint: 'Dibujar una columna, estantería, mampara o bloque de muebles.' },
      watch: { label: 'Objetivo de vigilancia', hint: 'Marcar una zona importante que debe captarse.' },
      privacy: { label: 'Zona privada', hint: 'Marcar una zona que no debe captarse.' },
      camera: { label: 'Cámara', hint: 'Colocar una cámara con un clic. A la derecha se abre el menú de modelos – el modelo adecuado ya está recomendado.' },
      text: { label: 'Texto', hint: 'Añadir nombres de habitaciones o etiquetas.' },
    },
    editor: {
      tools: 'Herramientas',
      autoSuggest: 'Sugerencias automáticas',
      analysis: 'Análisis de cobertura',
      properties: 'Propiedades',
      backToIntro: 'Volver al resumen del planificador de cámaras',
      resetTitle: '¿Restablecer el planificador?',
      resetText: 'Todos los elementos dibujados, las cámaras y el plano cargado se eliminarán permanentemente. Se eliminará el plan guardado.',
      cancel: 'Cancelar',
      confirmReset: 'Sí, restablecer',
      close: 'Cerrar',
      openTools: 'Abrir herramientas',
      openAnalysis: 'Abrir análisis',
      snap: 'Activar/desactivar ajuste a rejilla',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
      fit: 'Centrar plano',
      closeHints: 'Cerrar avisos',
    },
    canvas: {
      areaLabel: 'Superficie de dibujo del plano',
      calibHint: 'Establezca una distancia para el escalado',
      locked: 'bloqueado',
      scale: 'Escala: aprox. {{px}} px/m · Rejilla {{step}} m',
      calibNotice: 'Haga clic en dos puntos del plano cuya distancia conozca.',
    },
    props: {
      edit: 'Editar propiedades',
      delete: 'Eliminar',
      cameraModel: 'Modelo de cámara (dispositivo real)',
      nameNumber: 'Nombre / número',
      cameraCategory: 'Categoría de cámara',
      modelAssigned: 'El modelo "{{series}}" está asignado.',
      planningValues: 'Estos son valores de planificación, no datos técnicos de un producto real.',
      visibility: 'Visibilidad',
      recognition: 'Reconocimiento',
      detail: 'Detalle',
      rotation: 'Orientación (°)',
      fov: 'Ángulo de visión (°)',
      range: 'Alcance (m)',
      posX: 'Posición X (m)',
      posY: 'Posición Y (m)',
      mountHeight: 'Altura de montaje (m)',
      indoor: 'Interior',
      outdoor: 'Exterior',
      usage: 'Ámbito de uso',
      dayNight: 'Día / noche',
      target: 'Objetivo de vigilancia deseado',
      noneAssigned: 'Ninguno asignado',
      targetArea: 'Zona objetivo',
      remark: 'Observación',
      remarkPlaceholder: 'p. ej. notas sobre montaje o entorno...',
      coneNote: 'El cono de visión es una representación de planificación. La calidad real de imagen depende del modelo, objetivo, distancia, altura de montaje, luz y obstáculos en el lugar.',
      roomLabel: 'Denominación de la habitación',
      length: 'Longitud (m)',
      width: 'Anchura (m)',
      area: 'Superficie: aprox. {{area}} m²',
      designation: 'Denominación',
      points: '{{count}} puntos; mueva los puntos directamente sobre la superficie de dibujo.',
      wallThickness: 'Grosor de pared (m)',
      wallLength: 'Longitud: aprox. {{length}} m',
      wallNote: 'Las paredes macizas limitan las líneas de visión en el planificador.',
      obstacleKind: 'Tipo de obstáculo',
      shape: 'Forma',
      rect: 'Rectángulo',
      circle: 'Círculo',
      caption: 'Etiqueta',
      diameter: 'Diámetro (m)',
      depth: 'Profundidad (m)',
      goalKind: 'Tipo de objetivo',
      priority: 'Prioridad',
      goal: 'Objetivo deseado',
      coverageNote: 'La cobertura se valora por colores (verde / amarillo / rojo). Para objetivos de detalle se aplican requisitos más estrictos.',
      zoneKind: 'Tipo de zona',
      privacyNote: 'Si un cono de visión se solapa con esta zona, aparece una advertencia en el análisis.',
      textContent: 'Contenido de texto',
      duplicate: 'Duplicar',
      deleteElement: 'Eliminar elemento',
      projectData: 'Datos del proyecto',
      noElement: 'Ningún elemento seleccionado',
      projectName: 'Nombre del proyecto',
      objectType: 'Tipo de propiedad',
      objectTypePlaceholder: 'p. ej. vivienda unifamiliar',
      projectDescription: 'Descripción del proyecto',
      projectDescriptionPlaceholder: 'Particularidades, deseos o condiciones generales...',
      maxChars: 'Máximo 500 caracteres',
      cameraForNew: 'Modelo de cámara para cámaras nuevas',
      cameraForNewDesc: 'Seleccione abajo el modelo Safire deseado; el desplegable se abre automáticamente. Las cámaras nuevas se colocan con estos ajustes.',
      recommendedFor: 'Recomendado para su superficie:',
      orGeneric: 'o categoría genérica',
      tips: 'Consejos',
      tip1: 'Arrastrar espacio vacío con la herramienta de selección = mover superficie. Rueda del ratón = zoom.',
      tip2: 'Ctrl+Z = deshacer, Ctrl+Y = rehacer, Supr = eliminar elemento.',
      tip3: 'El ajuste a rejilla puede activarse/desactivarse en las opciones de vista.',
      suggestPositions: 'Sugerir posiciones de cámara automáticamente',
      doorSwing: 'Dirección de apertura',
      left: 'Izquierda',
      right: 'Derecha',
      none: 'Ninguna',
      attached: 'Colocado en una pared; arrastre a lo largo de la pared para moverlo. Al girar se libera el elemento.',
      detached: 'Colocado libre; muévalo y gírelo libremente.',
      doorNote: 'El material, el acristalamiento y el estado de apertura deben comprobarse en el lugar.',
    },
    result: {
      edit: 'Editar plan',
      print: 'Imprimir resumen',
      savePdf: 'Guardar como PDF',
      send: 'Enviar plan a SSG',
      eyebrow: 'Evaluación',
      title: 'Su plan preliminar de un vistazo',
      disclaimer:
        'Esta evaluación es un plan preliminar no vinculante. Solo se hará una recomendación definitiva tras comprobar las condiciones locales y seleccionar la tecnología de cámaras concreta.',
      project: 'Proyecto',
      objectType: 'Tipo de propiedad:',
      uploadPresent: 'Carga de plano disponible:',
      scaled: 'escalado',
      refDistance: 'm de distancia de referencia',
      notScaled: 'aún sin escalar',
      createdAt: 'Creado el',
      floorplan: 'Plano dibujado',
      noElements: 'Todavía no hay elementos en el plano.',
      stats: { rooms: 'Habitaciones y zonas', walls: 'Paredes', doors: 'Puertas', windows: 'Ventanas', obstacles: 'Obstáculos', cameras: 'Cámaras', zones: 'Zonas objetivo', privacy: 'Zonas privadas' },
      zonesTitle: 'Objetivos de vigilancia y prioridades',
      noZones: 'No hay objetivos de vigilancia marcados.',
      priorityLabel: 'Prioridad',
      goalLabel: 'Objetivo',
      goalOverview: 'Vista general',
      goalDetail: 'Detalle',
      goalObservation: 'Observación',
      coverage: 'cobertura geométrica',
      camerasTitle: 'Posiciones y tipos de cámara',
      noCameras: 'Todavía no hay cámaras colocadas.',
      modelLabel: 'Modelo',
      fovLabel: 'Ángulo de visión',
      visibilityLabel: 'Visibilidad aprox.',
      recognitionLabel: 'Reconocimiento aprox.',
      detailLabel: 'Detalle aprox.',
      positionLabel: 'Posición',
      rotationLabel: 'Orientación',
      rangeLabel: 'Alcance aprox.',
      mountLabel: 'Altura de montaje',
      indoor: 'Interior',
      outdoor: 'Exterior',
      day: 'Día',
      night: 'Noche',
      dayNight: 'Día y noche',
      target: 'Objetivo',
      assigned: 'Asignado',
      modelNote:
        'Los modelos Safire seleccionados se basan en valores de ficha técnica; visibilidad/reconocimiento/detalle son valores de planificación calculados (EN 62676-4). Sin modelo, los valores son genéricos, no datos técnicos de un producto real.',
      blindTitle: 'Posibles puntos ciegos y aspectos abiertos',
      uncovered: 'Zonas no cubiertas suficientemente:',
      privacyOverlaps: 'Solapamientos con zonas privadas:',
      checkPrivacy: 'Compruebe posición, orientación o enmascaramiento.',
      missingTitle: 'Faltan datos importantes',
      quickTitle: 'Funciones deseadas y datos de la propiedad',
      areasLabel: 'Zonas:',
      featuresLabel: 'Funciones:',
      areaLabel: 'Superficie:',
      recordingLabel: 'Grabación:',
      internetLabel: 'Internet:',
      powerLabel: 'Electricidad:',
      careInterest: 'Interés en la atención SSG Care',
      finalNote: 'El plan será revisado profesionalmente por SSG Signaltechnik. La altura de montaje, la iluminación, los ángulos y las condiciones del lugar determinan la ejecución final.',
      sendBottom: 'Enviar plan a SSG Signaltechnik',
      consult: 'Solicitar asesoramiento personal',
      good: 'Bien cubierto',
      partial: 'Parcialmente cubierto',
      insufficient: 'No suficiente',
    },
    send: {
      back: 'Atrás',
      title: 'Enviar plan a SSG Signaltechnik',
      lead:
        'Sus datos de planificación (plano, cámaras, ángulos de visión, objetivos de vigilancia, zonas privadas y resultado del análisis) se transmiten junto con sus datos de contacto. Los datos de contacto solo se necesitan ahora; el plan permanece localmente en su dispositivo.',
      dataTitle: 'Datos de planificación transmitidos',
      floorplan: 'Plano',
      rooms: 'Habitaciones/zonas',
      walls: 'Paredes',
      doors: 'Puertas',
      windows: 'Ventanas',
      obstacles: 'Obstáculos',
      cameras: 'Cámaras',
      none: 'ninguna',
      zones: 'Objetivos de vigilancia',
      privacy: 'Zonas privadas',
      analysis: 'Análisis',
      good: 'bien',
      partial: 'parcial',
      insufficient: 'no suficientemente cubierto',
      upload: 'Carga de plano',
      scaled: 'escalado',
      notScaled: 'sin escalar',
      customerType: 'Cliente particular o empresa *',
      privateCustomer: 'Cliente particular',
      businessCustomer: 'Cliente empresa',
      name: 'Nombre y apellidos *',
      company: 'Empresa (opcional)',
      phone: 'Número de teléfono',
      email: 'Correo electrónico *',
      projectAddress: 'Dirección del proyecto',
      projectAddressPlaceholder: 'Calle, código postal, ciudad',
      contactPref: 'Método de contacto preferido',
      any: 'Indiferente',
      byPhone: 'Teléfono',
      byEmail: 'Correo electrónico',
      callbackTime: 'Horario de devolución de llamada preferido',
      noCallback: 'No deseo devolución de llamada',
      morning: 'Mañana',
      afternoon: 'Tarde',
      evening: 'Noche',
      systemStatus: 'Sistema nuevo o existente',
      newSystem: 'Sistema nuevo',
      existingSystem: 'Sistema existente',
      unsure: 'Aún indeciso',
      existingManufacturer: 'Fabricante de un sistema existente (si lo conoce)',
      existingManufacturerPlaceholder: 'p. ej. Hikvision, Safire...',
      careInterest: 'Interés en SSG Care',
      careYes: 'Sí, infórmeme',
      careNo: 'No',
      careLater: 'Decidir más tarde',
      message: 'Mensaje adicional',
      messagePlaceholder: 'Añadidos a su plan...',
      fileUpload: 'Plano / fotos (opcional)',
      fileNote: 'Nota: las subidas de archivos se tratan como "Uncollectable"; los datos de planificación se transmiten como texto.',
      privacyConsent:
        'He leído la política de privacidad y acepto el tratamiento de mis datos para gestionar esta solicitud. Los datos de planificación se usan exclusivamente para su gestión. *',
      privacyLink: 'Política de privacidad',
      error: 'Se ha producido un error. Inténtelo de nuevo más tarde.',
      networkError: 'Error de red. Compruebe su conexión e inténtelo de nuevo.',
      successTitle: 'Gracias por su plan.',
      successText: 'SSG Signaltechnik revisará sus datos y se pondrá en contacto con usted personalmente.',
      sending: 'Enviando...',
      submit: 'Enviar plan a SSG',
      backToResult: 'Volver a la evaluación',
    },
    tour: {
      stepOf: 'Paso {{current}} de {{total}}',
      skip: 'Omitir',
      back: 'Atrás',
      next: 'Siguiente',
      finish: 'Empezar',
      dialogLabel: 'Introducción al planificador de cámaras',
      steps: {
        '0': { title: 'Bienvenido al planificador de cámaras de SSG', text: 'Dibuje su habitación o cargue un plano.' },
        '1': { title: 'Marcar zonas', text: 'Marque puertas, ventanas y zonas importantes.' },
        '2': { title: 'Colocar cámaras', text: 'Coloque cámaras o deje que se sugieran posiciones.' },
        '3': { title: 'Comprobar campos de visión', text: 'Compruebe los campos de visión y posibles puntos ciegos.' },
        '4': { title: 'Enviar plan', text: 'Envíe el plan preliminar a SSG Signaltechnik.' },
      },
    },
    analysis: {
      title: 'Análisis de cobertura',
      suggest: 'Sugerir posiciones',
      suggestTip: 'Sugerir posiciones de cámara',
      cameras: 'Cámaras',
      zones: 'Zonas objetivo',
      good: 'Bien cubierto',
      partial: 'Parcial',
      notCovered: 'Sin cubrir',
      privacyConflict: 'Conflicto de zona privada',
      areaCoverage: 'Cobertura geométrica de la superficie',
      areaNote: 'Cobertura representada geométricamente; no indica calidad real de imagen o reconocimiento.',
      legend: 'Leyenda',
      legendFov: 'Campo de visión de cámara',
      legendDetail: 'Reconocimiento de detalle nítido (discontinuo)',
      legendGood: 'Objetivo bien cubierto',
      legendPartial: 'Objetivo parcialmente cubierto',
      legendBad: 'Objetivo insuficiente',
      legendPrivacy: 'Zona privada / excluida',
      note: 'La valoración por colores es una orientación geométrica. Un ángulo de visión amplio no significa automáticamente suficiente reconocimiento de detalle; deben comprobarse la distancia, la resolución y la altura de montaje.',
    },
    upload: {
      title: 'Cargar plano',
      desc: 'Opcional: cargue un plano existente (JPG, PNG o WebP) como fondo. Luego marque una distancia conocida e introduzca su longitud para que el planificador escale correctamente.',
      choose: 'Seleccionar plano',
      chooseOther: 'Elegir otra imagen',
      remove: 'Eliminar',
      calibPrompt: 'Ahora haga clic en el punto A y el punto B del plano en la superficie de dibujo.',
      startCalib: 'Iniciar escalado',
      scaled: 'Escalado: {{cm}} cm por píxel · Distancia {{m}} m',
      lengthPlaceholder: 'Longitud en metros',
      apply: 'Aplicar',
      opacity: 'Opacidad {{pct}} %',
      lock: 'Bloquear fondo (evita movimientos accidentales)',
      moveHint: 'Para mover: arrastre un punto vacío de la imagen con la herramienta de selección (si no está bloqueado).',
      privacyNote: 'Los planos y las fotos de la propiedad pueden contener información sensible. Cargue solo archivos necesarios para gestionar su solicitud.',
      onlyImages: 'Seleccione solo imágenes JPG, PNG o WebP.',
      tooLarge: 'El archivo es demasiado grande. Seleccione una imagen de menos de 8 MB.',
      readError: 'No se pudo leer el archivo.',
      validLength: 'Introduzca una longitud válida en metros.',
      tooClose: 'Los puntos marcados están demasiado juntos.',
    },
    picker: {
      generic: 'Seleccionar categoría genérica',
      genericOption: 'Categoría genérica (sin modelo)',
      recommended: 'Recomendado',
      recommendation: 'Recomendación para su superficie',
      fovLabel: 'Ángulo de visión',
      detailFrom: 'Detalle desde aprox. {{detail}} m · Reconocimiento aprox. {{recognition}} m',
      hFov: 'Ángulo de visión horizontal',
      vFov: 'Ángulo de visión vertical',
      resolution: 'Resolución',
      lens: 'Objetivo',
      irRange: 'Alcance IR',
      ipClass: 'Clase de protección',
      audio: 'Audio',
      dayNight: 'Día / noche',
      datenblatt: 'Ficha técnica',
      planungswert: 'Valor de planificación',
      doriNote:
        'Visibilidad/reconocimiento/detalle: valores de planificación calculados según EN 62676-4 (densidad de píxeles). La calidad real de imagen depende del modelo, objetivo, altura de montaje, luz y obstáculos en el lugar.',
      groups: { standard: 'Estándar / interior y exterior', outdoor: 'Exterior', panorama180: 'Panorama', ptz: 'Paneo / zoom' },
    },
    quickswitch: {
      title: 'Cambiar modelo de cámara',
      subtitle: 'Cambiar variante directamente',
      active: 'Activo',
      recommended: 'Recomendado',
      note: 'Ajuste la orientación, el alcance y la altura de montaje en el panel de propiedades derecho.',
      close: 'Cerrar selección de modelo',
    },
    elementTypes: {
      room: 'Habitación / zona',
      polygon: 'Zona libre',
      wall: 'Pared',
      door: 'Puerta',
      window: 'Ventana',
      obstacle: 'Obstáculo',
      watchzone: 'Objetivo de vigilancia',
      privacy: 'Zona privada / excepción',
      camera: 'Cámara',
      text: 'Texto',
    },
    defaults: { room: 'Habitación', watchzone: 'Zona objetivo', text: 'Nombre de habitación' },
    defaultProject: 'Mi plan de cámaras',
    quickProject: 'Planificación de cámaras (comprobación rápida)',
    options: {
      objectTypes: {
        Einfamilienhaus: 'Vivienda unifamiliar',
        Mehrfamilienhaus: 'Edificio de viviendas',
        Wohnung: 'Piso',
        'Ladengeschäft': 'Tienda',
        'Büro oder Praxis': 'Oficina o consulta',
        Gastronomie: 'Hostelería',
        'Lager oder Logistik': 'Almacén o logística',
        Werkstatt: 'Taller',
        'Parkplatz oder Außenfläche': 'Aparcamiento o zona exterior',
        Baustelle: 'Obra',
        Sonstiges: 'Otro',
      },
      areas: {
        Haupteingang: 'Entrada principal',
        Nebeneingang: 'Entrada secundaria',
        Fenster: 'Ventana',
        Einfahrt: 'Acceso',
        Garage: 'Garaje',
        'Garten oder Terrasse': 'Jardín o terraza',
        Kasse: 'Caja',
        Verkaufsfläche: 'Sala de ventas',
        Lager: 'Almacén',
        Lieferzone: 'Zona de reparto',
        Parkplatz: 'Aparcamiento',
        'Büro oder Innenraum': 'Oficina o interior',
        'Gesamte Außenfläche': 'Toda la zona exterior',
        'Sonstiger Bereich': 'Otra zona',
      },
      features: {
        'Live-Ansicht': 'Vista en directo',
        'lokale Aufzeichnung': 'Grabación local',
        'Smartphone-Zugriff': 'Acceso desde el móvil',
        'Wiedergabe gespeicherter Aufnahmen': 'Reproducción de grabaciones guardadas',
        Ereignisbenachrichtigungen: 'Notificaciones de eventos',
        'gute Sicht bei Dunkelheit': 'Buena visibilidad en la oscuridad',
        'Übersicht über eine große Fläche': 'Vista general de una gran superficie',
        'Erkennung wichtiger Details': 'Reconocimiento de detalles importantes',
        'mehrere Benutzer': 'Varios usuarios',
        'mehrere Standorte': 'Varias ubicaciones',
        'vorhandene Anlage erweitern': 'Ampliar sistema existente',
        'SSG-Care-Betreuung': 'Atención SSG Care',
      },
      recordingDurations: {
        'Bis 7 Tage': 'Hasta 7 días',
        'Bis 14 Tage': 'Hasta 14 días',
        'Bis 30 Tage': 'Hasta 30 días',
        'Mehr als 30 Tage': 'Más de 30 días',
        'noch unklar': 'aún sin aclarar',
      },
      roomNames: {
        Eingang: 'Entrada',
        Flur: 'Pasillo',
        Wohnzimmer: 'Salón',
        'Büro': 'Oficina',
        Verkaufsfläche: 'Sala de ventas',
        Kasse: 'Caja',
        Lager: 'Almacén',
        Werkstatt: 'Taller',
        Parkplatz: 'Aparcamiento',
        Außenbereich: 'Zona exterior',
      },
      obstacles: {
        saeule: 'Columna',
        regal: 'Estantería',
        trennwand: 'Mampara alta',
        moebel: 'Bloque de muebles',
        fahrzeug: 'Plaza de vehículo',
        eigen: 'Obstáculo con nombre',
      },
      watchKinds: {
        ueberblick: 'Abarcar por completo la zona',
        eingang: 'Observar la entrada',
        tuer: 'Vigilar puerta',
        fenster: 'Vigilar ventana',
        kasse: 'Captar caja o punto sensible',
        zufahrt: 'Observar acceso',
        kennzeichen: 'Comprobar zona de matrículas',
        flaeche: 'Vista general de una superficie',
        details: 'Reconocer detalles importantes',
        individuell: 'Zona individual',
      },
      watchPriorities: { normal: 'Normal', wichtig: 'Importante', kritisch: 'Crítico' },
      watchGoals: { uebersicht: 'Vista general', beobachtung: 'Observación', detail: 'Detalle' },
      privacyKinds: {
        privat: 'Zona privada',
        nachbar: 'Parcela vecina',
        oeffentlich: 'Acera o calle pública',
        mitarbeiter: 'Zona de empleados',
        ausgeschlossen: 'Zona que no debe captarse',
      },
      categories: {
        standard: { label: 'Cámara estándar', hint: 'Versátil para interiores y exteriores' },
        wide: { label: 'Cámara gran angular', hint: 'Visión amplia a corta/media distancia' },
        varifocal: { label: 'Cámara con ángulo variable', hint: 'El ángulo se ajusta en el lugar' },
        panorama180: { label: 'Cámara panorámica 180°', hint: 'Captura muy amplia, reconocimiento de detalle limitado' },
        fisheye360: { label: 'Cámara 360° / ojo de pez', hint: 'Vista completa, imagen corregida electrónicamente' },
        ptz: { label: 'Cámara PTZ', hint: 'Cámara de paneo/inclinación/zoom para grandes superficies' },
        indoor: { label: 'Cámara interior', hint: 'Optimizada para interiores' },
        outdoor: { label: 'Cámara exterior', hint: 'Versión resistente a la intemperie para exteriores' },
      },
      dayNight: { tag: 'Día', nacht: 'Noche', beides: 'Día y noche' },
    },
    models: {
      'safire-turret-i1-4mp': { ai: 'Clasificación de personas y vehículos (IA)', note: 'Cámara turret versátil con gran ángulo de visión: un buen estándar para interiores y exteriores.' },
      'safire-turret-e1-4mp': { ai: 'Clasificación de personas y vehículos (IA)', note: 'Modelo básico asequible de la serie E1 con resolución sólida.' },
      'safire-turret-b1-4mp': { ai: '', note: 'Turret económica y robusta con carcasa resistente a impactos (IK10).' },
      'safire-dome-i2-8mp': { ai: 'Clasificación de personas y vehículos (IA)', note: 'Alta resolución de 8 MP: más detalle en la misma sección de imagen.' },
      'safire-bullet-4mp': { ai: 'Clasificación de personas y vehículos (IA)', note: 'Diseño bullet clásico para montaje exterior. Ángulo de visión como valor de planificación según la serie.' },
      'safire-turret-nightcolor-4mp': { ai: 'Imagen en color en la oscuridad (NightColor X)', note: 'Ofrece imagen en color incluso con poca luz: ideal para situaciones nocturnas críticas. Ángulo de visión como valor de planificación.' },
      'safire-turret-duallight-4mp': { ai: 'Clasificación de personas y vehículos (IA)', note: 'DualLight con LED infrarrojo y de luz blanca (30 m cada uno): flexible de noche. Ángulo de visión como valor de planificación.' },
      'safire-panorama-180-8mp': { ai: 'Vista panorámica de 180° con altavoz y micrófono', note: 'Capta una zona muy amplia con una cámara; el reconocimiento de detalle a distancia es limitado.' },
      'safire-miniptz-4mp': { ai: 'Seguimiento automático, clasificación de personas y vehículos', note: 'Cámara PTZ con seguimiento automático. Ángulo de visión como valor de planificación (posición final gran angular).' },
      'safire-ptz-15x-2mp': { ai: 'Seguimiento automático, seguimiento de coches y vehículos', note: 'Gran alcance gracias al zoom 15× e IR de 200 m. Ángulo de visión como valor de planificación (posición final gran angular).' },
    },
    disclaimer: {
      general:
        'El planificador de cámaras ofrece un plan preliminar no vinculante. La sección de imagen real y la posición de cámara adecuada dependen, entre otros, del modelo, el objetivo, la distancia, la altura de montaje, la iluminación, los obstáculos y las condiciones del lugar.',
      result:
        'Esta evaluación es un plan preliminar no vinculante. Solo se hará una recomendación definitiva tras comprobar las condiciones locales y seleccionar la tecnología de cámaras concreta.',
      upload: 'Los planos y las fotos de la propiedad pueden contener información sensible. Cargue solo archivos necesarios para gestionar su solicitud.',
      sichtfeld: 'Las puertas y ventanas pueden afectar a las líneas de visión. El material, el acristalamiento, el estado de apertura y el reflejo de luz deben comprobarse en el lugar.',
      datenschutz:
        'Para requisitos como reconocimiento facial, identificación de personas o reconocimiento de matrículas se requiere una revisión técnica y de protección de datos.',
    },
    hints: {
      '0':
        'Según su información, pueden ser adecuadas varias posiciones o tipos de cámara. Para una recomendación fiable, deben comprobarse los ángulos de visión, la altura de montaje, la iluminación y los obstáculos existentes.',
      '1':
        'Un ángulo de visión amplio no significa automáticamente suficiente reconocimiento de detalle. La distancia, la resolución, el ángulo, la altura de montaje y el objetivo influyen en la calidad real de imagen.',
      '2': 'La altura de montaje y las condiciones de iluminación deben comprobarse en el lugar.',
    },
    recommend: {
      noArea: 'Recomendación estándar mientras no se haya dibujado ninguna superficie. Dibuje su habitación y la recomendación se ajustará.',
      veryLarge: 'Superficie muy grande (aprox. {{area}} m²): PTZ con zoom y gran alcance para distancias amplias.',
      large: 'Superficie grande (aprox. {{area}} m²): diseño bullet robusto para exteriores.',
      medium: 'Superficie media a grande (aprox. {{area}} m²): 8 MP para más detalle en anchura.',
      compact: 'Superficie compacta (aprox. {{area}} m²): un gran ángulo de visión cubre bien la habitación.',
    },
    analysisDynamic: {
      missingNoCameras: 'Todavía no hay cámaras colocadas.',
      missingNoRooms: 'Todavía no se han dibujado habitaciones o superficies.',
      missingNoWalls: 'No se han dibujado paredes; los conos de visión no se limitan.',
      missingNoZones: 'No hay objetivos de vigilancia marcados.',
      missingNoPrivacy: 'No hay zonas privadas o de exclusión marcadas.',
      missingNoInternet: 'Falta información sobre la conexión a internet.',
      missingNoPower: 'Falta información sobre el suministro eléctrico.',
      hintUncovered: 'Zonas objetivo sin cobertura suficiente: compruebe las posiciones de cámara o planifique cámaras adicionales.',
      hintPartial: 'Algunas zonas objetivo solo están parcialmente cubiertas; ajuste ángulo, posición o alcance.',
      hintDetailRange: 'El alcance de detalle de "{{name}}" (aprox. {{range}} m) probablemente no basta para habitaciones grandes por sí solo; una cámara adicional podría ser útil.',
      hintPrivacy: 'El campo de visión se solapa con una zona privada marcada. Deben comprobarse la posición, la orientación o el enmascaramiento técnico.',
      hintMount: 'La altura de montaje y las condiciones de iluminación deben comprobarse en el lugar.',
      hintKennzeichen: 'Se requiere revisión técnica y de protección de datos.',
      noteDetailRange:
        'El reconocimiento de detalle probablemente no es suficiente para aprox. {{distance}} m de distancia; detalle máx. aprox. {{identification}} m. Debería comprobarse un ángulo más estrecho o un modelo con mayor resolución.',
      noteDetailUncertain: 'El reconocimiento de detalle a larga distancia es incierto; deben comprobarse un ángulo más estrecho y la altura de montaje.',
      notePartial: 'Esta zona puede estar solo parcialmente cubierta.',
      suggestNear: 'El objetivo de vigilancia "{{target}}" está cerca de "{{privacy}}". La posición y la orientación deben elegirse con cuidado; se requiere revisión de protección de datos.',
      suggestHeuristic: 'Las sugerencias son heurísticas. Cada cámara puede moverse, girarse, cambiarse o eliminarse libremente.',
      suggestWide: 'Un ángulo de visión amplio no significa suficiente reconocimiento de detalle. La distancia, la resolución y la altura de montaje afectan a la calidad de imagen.',
      cameraNoteDetail: 'Primera posición de cámara posible; planifique un ángulo más estrecho para objetivos de detalle.',
      cameraNoteCheck: 'Primera posición de cámara posible; compruébela y ajústela.',
      cameraSuggestion: 'Sugerencia {{count}}',
      uncoveredPartial: 'parcial',
      uncoveredInsufficient: 'no suficiente',
      toastNoPositions: 'No se encontraron posiciones nuevas. Añada objetivos de vigilancia o habitaciones.',
      toastSuggested: '{{count}} primera(s) posición(es) de cámara posible(s) sugerida(s).',
    },
  },
};